

import moment from 'moment'

export const helperDatas = {
  dataBrasil, dataAtual, anoAtual, dataHoraBrasil, dataHoraAtual, dataUSA, dataAtualBrasil, dataAtualFormat, dataFromTo, dataHoraAtualHtml5
};

function dataBrasil(value){
  let val = value!=null && value!='' ? moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY') : "";
  return val;
}

function dataAtual(){
 return moment().format('YYYY-MM-DD')
}

function anoAtual(){
  return moment().format('YYYY')
 }


function dataAtualFormat(format){
  return moment().format(format)
 }
 


function dataAtualBrasil(){
    return moment().format('DD/MM/YYYY')
}


function dataHoraAtual(){
    return moment().format('YYYY-MM-DD HH:mm:ss')
}


function dataHoraAtualHtml5(){
  return moment().format('YYYY-MM-DDTHH:mm')
}


function dataHoraBrasil(value){
    let val = value!=null && value!='' ?moment(value, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss') : "";
    return val;
  }

function dataUSA(value) {
  let val = moment(value, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
  return val;
}

function dataFromTo(value, formatEntrada, formatSaida){
  let val = value!=null && value!='' ? moment(value, formatEntrada).format(formatSaida) : "";
  return val;
}

/*
const dataBrforUS = (value) => {
  let val = moment(value, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD');
  return val;
}


const dataVueCalendar = (value) => {
  let val = moment(value, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('YYYY-MM-DD HH:mm:ss');
  return val;
}*/